import './styles/Typewriter.css';

function Typewriter() {
  return (
    <header className="typewriter-header">
      <div className="hero-frame">
        <span className="hero-corner tl"></span>
        <span className="hero-corner tr"></span>
        <span className="hero-corner bl"></span>
        <span className="hero-corner br"></span>

        <div className="hero-meta">
          <span className="meta-tag">// IDENTITY_BLOCK_01</span>
          <span className="meta-tag right">ENGAGED</span>
        </div>

        <div className="typewriter-status">
          <span className="dot"></span>
          <span className="status-label">STATUS</span>
          <span className="status-sep">::</span>
          BUILDING <a href="https://certiv.ai" target="_blank" rel="noopener noreferrer">CERTIV.AI</a>
        </div>

        <div className="typewriter">
          <h1>Hey, I'm Dan</h1>
        </div>

        <div className="typewriterSmall">
          <h2>Welcome to my portfolio</h2>
        </div>

        <div className="hero-readout">
          <div className="readout-row">
            <span className="k">ROLE</span>
            <span className="v">Co-Founder · Chief AI Officer</span>
          </div>
          <div className="readout-row">
            <span className="k">ORG</span>
            <span className="v"><a href="https://certiv.ai" target="_blank" rel="noopener noreferrer">Certiv</a> · agent runtime security · $4M funded</span>
          </div>
          <div className="readout-row">
            <span className="k">PRIOR</span>
            <span className="v">Microsoft Research · Pioneer Square Labs · Atrieon.AI</span>
          </div>
        </div>
      </div>

      <div className="typewriter-scroll-cue">
        <span className="chevron"></span>
        <span>SCROLL // INIT_TRAJECTORY</span>
        <span className="chevron"></span>
      </div>
    </header>
  );
}

export default Typewriter;
